import { canEditSection } from '@/lib/access';
import React from 'react';
import { useManualForm, FormShell, RepeatTable } from './_shared';
import { Card } from '@/components/UI';

const DEFAULT = { changes: [] };

const COLS = [
  { key: 'sr_no', label: '#', type: 'number' },
  { key: 'change_type', label: '4M Type', type: 'select', options: ['Man', 'Machine', 'Material', 'Method'] },
  { key: 'description', label: 'Description', type: 'textarea' },
  { key: 'affected_part', label: 'Affected Part' },
  { key: 'affected_process', label: 'Affected Process' },
  { key: 'customer', label: 'Customer' },
  { key: 'change_date', label: 'Change Date', type: 'date' },
  { key: 'validation_status', label: 'Validation', type: 'select', options: ['validated', 'pending', 'failed'] },
  { key: 'validation_date', label: 'Validation Date', type: 'date' },
  { key: 'validated_by', label: 'Validated By' },
  { key: 'remarks', label: 'Remarks' },
];

export default function ChangePoints() {
  const ctx = useManualForm('change_points', DEFAULT);
  const canEdit = canEditSection(ctx.user, 'quality');
  const locked = ctx.currentCycle?.status === 'locked';
  const set = (rows) => ctx.setData({ ...ctx.data, changes: rows });
  return (
    <FormShell title="4M Change Points" subtitle="Track Man / Machine / Material / Method changes and validation" status={ctx.status} save={ctx.save} submit={ctx.submit} saving={ctx.saving} submitting={ctx.submitting} canEdit={canEdit} locked={locked}>
      <Card title="Change Points">
        <RepeatTable rows={ctx.data.changes || []} columns={COLS} onChange={set} addLabel="Add Change Point" defaultRow={{ sr_no: (ctx.data.changes||[]).length + 1, change_type: 'Method', validation_status: 'pending' }} />
      </Card>
    </FormShell>
  );
}
